module.exports = __webpack_public_path__ + "static/media/lime_logo_leaf.6055d8e7.png";